import * as yup from 'yup'
import { mediaSchema, validateMedia } from '@/components/inputs'
import {
  BIRDS_BEHAVIOUR_BALLSEND,
  DIRECTION_BIRD_GEDRAG_OPTION_VALUE,
  OTHER_GEDRAG_OPTION_VALUE,
  OTHER_SPECIE_OPTION_VALUE,
  PLACE_FOUND_OPTION_VALUE,
} from '@/components/forms/ObservationLogFormContainer/fieldsOptions'
import translation from 'i18next'

export const schema = yup.object({
  specie: yup.string().required(),
  other_specie: yup.string().when('specie', {
    is: OTHER_SPECIE_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  amount: yup.string().required(),
  counting_method: yup.string().required(),
  behaviour: yup.string().required(),
  other_behaviour: yup.string().when('behaviour', {
    is: OTHER_GEDRAG_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  behaviour_notes: yup.string().max(256),
  is_place_found: yup.string().required(),
  address: yup.string().when('is_place_found', {
    is: PLACE_FOUND_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  direction: yup.string().when('behaviour', {
    is: DIRECTION_BIRD_GEDRAG_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  recording_number: yup
    .string()
    .transform((value) => (value === '' || value === null ? undefined : value)),
  observed_at: yup.date().required(),
  photos: mediaSchema.when(['is_place_found', 'behaviour'], {
    is: (is_place_found: string, behaviour: string) =>
      is_place_found === PLACE_FOUND_OPTION_VALUE &&
      behaviour !== BIRDS_BEHAVIOUR_BALLSEND,
    then: (schema) =>
      schema.test(
        'valid-photos',
        translation.t('errors:validation.requiredImagesWhenBehaviour'),
        (value) => validateMedia({ value, minItems: 1 })
      ),
    otherwise: (schema) => schema.optional(),
  }),
  sound_recordings: mediaSchema.test((value, context) =>
    validateMedia({
      value,
      minItems: 0,
      maxItems: 1,
      accept: 'audio/wav,audio/x-wav',
      context,
      description: true,
    })
  ),
})
